<template>
    <div>
      <div v-if="cartCount > 0" >
        <div>
          <h2 class="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">Order Summary</h2>
          <ul role="list" class="divide-y divide-gray-200 dark:divide-gray-800">
            <li v-for="item in cartProducts" :key="item.sku" class="py-6 flex">
              <div class="flex-1 flex items-start">
                <div v-if="item.thumb" class="bg-gray-50 dark:bg-gray-800 aspect-video rounded w-32 mr-4">
                  <img :src="item.thumb" alt="" class="object-cover block h-full" />
                </div>
                <div class="w-full">
                  <div class="flex justify-between">
                    <h3 class="font-bold">
                      {{ item.title }}
                    </h3>
                    <p class="ml-4 font-bold">
                      £{{ item.price }}
                    </p>
                  </div>
                  <div v-if="item.option">
                    <p>
                      <span>Location:</span> <strong>{{ item.option.location ? item.option.location.city : 'Online'}}</strong>
                    </p>
                    <p>
                      <span>Start Date:</span> <strong>{{ item.option.start_date | moment("MMM Do YYYY - HH:mm") }}</strong>
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <hr class="dark:border-gray-800">
          <div class="flex justify-between mt-8" v-show="cartDiscountAmount > 0">
            <p class="font-bold">Discount</p>
            <p class="font-bold">£{{ cartDiscountAmount }}</p>
          </div>
            <div class="flex justify-between mt-8">
            <p class="font-bold">Total</p>
            <p class="font-bold">£{{ cartTotal }}</p>
          </div>
            <div class="mt-8">
                <p class="font-bold">Got a discount code?</p>
                <p v-if="loggedIn !== true" class="text-sm">You must be logged in to apply a discount code.</p>
            </div>
            <div class="flex justify-between mt-4 grid grid-cols-3 gap-x-12 gap-y-4">
                <div class="col-span-3 md:col-span-2">
                    <input type="text" placeholder="Discount Code" :disabled="discount.loading || cartDiscountAmount > 0" v-model="discount.code" class="accent-primary-500 px-3 py-1.5 border bg-white border-gray-200 dark:bg-gray-900 dark:border-gray-700 dark:focus:border-gray-500 block rounded transition duration-200 ease-in-out focus:ring-2 focus:ring-gray-500 focus:outline-none focus:ring-opacity-25 disabled:opacity-50 disabled:cursor-not-allowed focus:border-gray-500 w-full shadow-sm"/>
                </div>
                <div class="col-span-3 md:col-span-1">
                    <bc-button variant="primary" type="button" :aria-disabled="discount.loading" @click="applyDiscount" v-if="!cartDiscountAmount">
                        <span v-if="discount.loading" class="inline-flex items-center">
                            <svg class="animate-spin -ml-2 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Processing...
                        </span>
                        <span v-else>Apply Discount</span>
                    </bc-button>
                    <bc-button variant="primary" type="button" :aria-disabled="discount.loading" @click="clearDiscount" v-else>
                        Remove Discount
                    </bc-button>
                </div>
                <div class="col-span-3 mt-4" v-show="discount.error || discount.success">
                    <div class="text-green-800 px-4 py-2 border-0 rounded relative bg-green-100" v-show="discount.success">Discount has been applied.</div>
                    <div class="text-white px-4 py-2 border-0 rounded relative bg-red-500" v-show="discount.error">{{ discount.error }}</div>
                </div>
            </div>

            <div class="flex mt-8">
                <p class="text-xs">Prices inclusive of VAT.</p>
            </div>
        </div>
      </div>
      <div v-else>
        <p class="prose">
          You have no items in your shopping cart.
          <a href="/" class="text-primary-600 font-medium hover:text-primary-500">Continue Shopping<span aria-hidden="true"> &rarr;</span></a>
        </p>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BcAlert from "../../admin/components/Alert";
export default {
  name: 'AppCheckoutCart',
    components: {BcAlert},
    data () {
    return{
      items: [],
        discount: {
            code: null,
            error: false,
            success: false,
            loading: false,
            details: {
                id: null,
                discount_type: null,
                discount_value: null,
            }
        },
    }
  },
    props: {
        loggedIn: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
  computed: {
    ...mapGetters('cart', ['cartCount', 'cartProducts', 'cartSubTotal', 'cartTotal', 'cartDiscount', 'cartDiscountAmount']),
  },
    methods: {
      toggleDiscount() {
          this.discount.show = !this.discount.show;
      },
        applyDiscount() {
            if(!this.discount.code) {
                return false;
            }

            this.discount.loading = true;
            this.discount.success = false;
            this.discount.error = false;

            axios.post('/api/checkout/discount', {code: this.discount.code})
                .then((response) => {
                    if(response.data.error) {
                        this.discount.error = response.data.error;
                        this.clearDiscount();
                        let self = this; setTimeout(function () { self.discount.error = false; } , 2000);
                    } else if(response.data.success) {
                        this.discount.success = true;
                        this.discount.details.id = response.data.discount.id;
                        this.discount.details.discount_type = response.data.discount.discount_type;
                        this.discount.details.discount_value = response.data.discount.discount_value;

                        this.$store.dispatch('cart/setDiscountCode', this.discount);

                        let self = this; setTimeout(function () { self.discount.success = false; } , 2000);
                    }
                })
                .catch((err) => {
                    console.log(err.response);
                    if(err.response.status === 401) {
                        this.discount.error = 'Please login to apply a discount code';
                    } else {
                        this.discount.error = err.response.data.errors;
                    }
                    this.clearDiscount();
                    let self = this; setTimeout(function () { self.discount.error = false; } , 2000);
                })
                .then(() => {
                    this.discount.loading = false;
                })
        },
        clearDiscount() {
            this.$store.dispatch('cart/clearDiscount').then(() => {
                this.discount.code = this.cartDiscount.code;
                this.discount.details = this.cartDiscount.details;
            });
        },
        trimNumber(number) {

        }
    },
  mounted () {
    this.items = this.cartProducts.map(item => {
      return {
        title: item.title,
        price: item.price,
        quantity: item.quantity,
        sku: item.sku,
        option: {
          programme_id: item.id,
          group_id: item.option ? item.option.id : 0
        }
      }
    });

      if(this.cartDiscount.code) {
          this.discount.show = true;
          this.discount.code = this.cartDiscount.code;
          this.discount.details = this.cartDiscount.details;
      }
  }
}
</script>
